import { render, staticRenderFns } from "./AppBarBasket.vue?vue&type=template&id=2a240efe&"
import script from "./AppBarBasket.vue?vue&type=script&lang=js&"
export * from "./AppBarBasket.vue?vue&type=script&lang=js&"
import style0 from "./AppBarBasket.vue?vue&type=style&index=0&id=2a240efe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
